import React from 'react';
import styled from '../../styled-components';

type PropType = { children: React.ReactNode; withError: boolean; className?: string };

const Label = (props: PropType) => (
  <LabelCmp {...props} className={`form-input-label ${props.className || ''}`}>
    {props.children}
  </LabelCmp>
);

const LabelCmp = styled.label`
  color: #333;
  display: block;
  font-weight: bold;
  padding: 15px 0 5px 0;
  width: 100%;

  &.auth-style {
    color: #999;
    font-weight: 700;
    text-transform: uppercase;
  }
`;

export default Label;
